import { useApi } from 'utils'
import * as yup from "yup"
import toast from 'react-hot-toast'
import { Controller, FormProvider, useFieldArray, useForm, useWatch } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { ActionButton, BaseTable, Button, Card, HeaderMenu, Input, Loading, Modal, NumberInput, PaginationData, TableNumber, Select } from 'components'
import { useLocation, useNavigate } from 'react-router-dom'
import { FaPlus, FaRegSave } from 'react-icons/fa'
import { CreateModal as PopupCategory } from "../../../../Setup/Preference/CategoryCustomer/components/CreateModal"
import { CreateModal as PopupPriceLevel } from "../../../../Setup/Preference/PriceLevelCustomer/components";
import { CreateModal as PopupPaymentTerm } from "../../../../Setup/Preference/PaymentTermCustomer/components";
import { CreateModal as PopupBank } from "../../../../Setup/Preference/Bank/components";
import { CreatePage as NewEmployee } from "../../../../Card/Transaction/CreateNewEmployee/components"
import { useEffect, useState } from 'react'
import { useDetail } from '../utils' 
import { StatusEnum } from '..'
import { PaginationState } from 'types'
import { useBank, useMarketing, usePaymentTerm, useTypeAddress } from 'pages/Card/Transaction/CreateNewCustomer/components/FormSection/utils'
import { useCountry, useProvince, useRegency, useSubdistrict, useVillage } from 'pages/Setup/Preference/Location/components/FormSection/utils'
import { CustomertReview } from '../types'
import { useCategory, usePriceLevel } from 'pages/Card/Transaction/CreateNewCustomer/components/FormSection/utils'

const default_pagination_value = {
  total: 0,
  page: 1,
  limit: 50,
  pages: 1,
  keyword: "",
}

export const ReviewPageCustomer = () => {
  const navigate = useNavigate()
  const api = useApi()
  const location = useLocation()
  const dataPage = location?.state

  const dataCardLabel = [
    { value: "1", label: "Individu" },
    { value: "2", label: "Company" },
  ]
  const dataGroup = [
    { value: "1", label: "Employee" },
    { value: "2", label: "Customer" },
    { value: "3", label: "Vendor" },
  ]

  const [pagination, setPagination] = useState<PaginationState & { identity_batch?: string, file_status?: number }>({ ...default_pagination_value, identity_batch: dataPage?.identity_batch, file_status: dataPage?.status! })
  const dataSingle = useDetail(pagination)

  const [modalConfig, setModalConfig] = useState({ show: false, action: "", data: {} })
  const [checkedIndexes, setCheckedIndexes] = useState<number[]>([]);
  
  const productCategory = useCategory()
  const productMarketing = useMarketing()
  const productPriceLevel = usePriceLevel()
  const productPaymentTerm = usePaymentTerm()
  const productBank = useBank()
  const productTypeAddress = useTypeAddress()
  const productCountry = useCountry()
  const productProvince = useProvince()
  const productRegency = useRegency()
  const productSubdistrict = useSubdistrict()
  const productVillage = useVillage()

  const isLoadingArray = [
    dataSingle?.isLoading,
    productCategory?.isLoading,
    productPriceLevel?.isLoading,
    productPaymentTerm?.isLoading,
    productBank?.isLoading,
    productTypeAddress?.isLoading,
    productCountry?.isLoading,
    productProvince?.isLoading,
    productRegency?.isLoading,
    productSubdistrict?.isLoading,
    productVillage?.isLoading
  ];
  
  const tableLoading = isLoadingArray.some(Boolean);

  const validationSchema = yup.object().shape({ datavalue: yup.array().label("Data list").defined() })
  const methods = useForm<any>({
    defaultValues: { datavalue: "" },
    resolver: yupResolver(validationSchema)
  })
  const { fields } = useFieldArray({ control: methods.control, name: "datavalue" })
  const dataReview = useWatch({ control: methods.control, name: "datavalue" });

  const hasEmptyFields = () => dataReview?.some((item: any) => !item?.customer_name )
  const isDisabled = dataReview?.length > 0 && hasEmptyFields();

  const getSelectedData = () => {
    if(dataReview) {
      return dataReview?.filter((_: any, index: any) => checkedIndexes?.includes(index));
    }
  };
  const selectedData = getSelectedData();

  const sanitizeWholesale = (data: CustomertReview) => {
    const sanitizeString = (value: string | undefined): string => {
      if (!value) return "";
      let sanitized = String(value)?.replace(/,/g, "");
      if (sanitized?.endsWith(".00")) {
        sanitized = sanitized.slice(0, -3);
      }
  
      return sanitized;
    };

    return {
      ...data,
      max_balance: data?.max_balance ? sanitizeString(data?.max_balance) : null,
      bank_account: data?.bank_account ? sanitizeString(data?.bank_account) : ""
    };
  }
  const sanitizeWholesaleMap = (data: CustomertReview[]): CustomertReview[] => {
    const sanitizeString = (value: string | undefined): string => {
      if (!value) return "";
      let sanitized = String(value)?.replace(/,/g, "");
      if (sanitized?.endsWith(".00")) {
        sanitized = sanitized.slice(0, -3);
      }
  
      return sanitized;
    };
  
    return data.map((item) => ({
      ...item,
      max_balance: item?.max_balance ? sanitizeString(item?.max_balance) : null,
      bank_account: item?.bank_account ? sanitizeString(item?.bank_account) : ""
    }));
  };

  const handleCreateSingle = () => {
    return new Promise<void>((resolve) => {
      const sanitizedSelect = sanitizeWholesaleMap(selectedData);
      const sanitizedReview = sanitizeWholesaleMap(dataReview);
      const payloadMapper = selectedData?.length !== 0 ? sanitizedSelect : sanitizedReview
      
      toast.promise(
        api.post(`/import-customer/posting-customer`, payloadMapper),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.message ?? err.response.message
        }
      )
      .then(() => {
        dataSingle.refetch()
        selectedData?.length === 0 && navigate(-1)
        setCheckedIndexes([])
      })
      .catch(() => {
        // dataSingle.refetch()
        setCheckedIndexes([])
      })
      .finally(resolve)
    })
  }
  const handleUpdateSingle = (data: CustomertReview) => {
    const sanitizedData = sanitizeWholesale(data);

    return new Promise<void>((resolve) => {
      toast.promise(
        api.post(`/import-customer/posting-customer`, [sanitizedData]),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.message ?? err.response.message
        }
      )
      .then(() => dataSingle.refetch())
      .catch(() => {})
      .finally(resolve)
    })
  }
  const handleDeleteSingle = (id: number) => {
    return new Promise<void>((resolve) => {
      toast.promise(
        api.delete(`/import-customer/delete-single/${id}`),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.message ?? err.response.message
        }
      )
      .then(() => dataSingle.refetch())
      .catch(() => dataSingle.refetch())
      .finally(resolve)
    })
  }
  const handleCheckboxChange = (index: number) => {
    setCheckedIndexes((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index)
        : [...prev, index]
    );
  };
  const handleCheckAllChange = () => {
    if (checkedIndexes.length === dataReview.length) {
      setCheckedIndexes([]);
    } else {
      setCheckedIndexes(dataReview.map((_: any, index: any) => index));
    }
  };

  const inputClass = "my-[-4px]! mx-[-8px]!"
  const borderTH = "border-2 border-[#A6AEBF]"

  useEffect(() => {
    if (dataSingle?.data?.payload) {
      methods.reset({ datavalue: dataSingle?.data?.payload });
    }
    // eslint-disable-next-line
  }, [dataSingle?.data?.payload, methods.reset]);

  if(dataSingle?.isLoading) {
    return (
      <section className="container pt-5  gap-5 flex flex-col">
        <HeaderMenu title="REVIEW CUSTOMER IMPORT" />

        <Card>
          <Card.Body>
            <Loading loading={dataSingle?.isLoading} />
          </Card.Body>
        </Card>
      </section>
    )
  }

  return (
    <section className="container gap-5 flex flex-col">
      <HeaderMenu title="REVIEW CUSTOMER IMPORT" />

      <FormProvider {...methods}>
        <div className="overflow-auto max-h-[500px]">
          <BaseTable>
            <thead className='bg-[#EEEEEE] sticky top-0 z-[1]'>
              <tr>
                <th className={borderTH} rowSpan={2}>NO</th>
                <th className={borderTH} colSpan={17}>VENDOR PROFILE</th>
                <th className={borderTH} colSpan={7}>VENDOR ADDRESS</th>
                <th className={borderTH} rowSpan={2}>STATUS</th>
                {dataPage?.status === 1 && <th className={borderTH} rowSpan={2}>ACTION</th>}
                {dataPage?.status === 1 && <th className={borderTH} rowSpan={2}>
                  SUBMIT<br/>ITEMS
                  <div>
                    <input
                      type='checkbox'
                      className='w-[22px] h-[22px] checkbox checkbox-primary mt-2'
                      checked={checkedIndexes.length === dataReview.length}
                      onChange={handleCheckAllChange}
                      >
                      
                    </input>
                  </div>
                </th>}
              </tr>
              <tr>
                <th className={borderTH}>FULL NAME</th>
                <th className={borderTH}>HANDPONE</th>
                <th className={borderTH}>EMAIL</th>
                <th className={borderTH}>WEBSITE</th>
                <th className={borderTH}>CARD LABEL</th>
                <th className={borderTH}>GROUP</th>
                <th className={borderTH}>CATEGORY</th>
                <th className={borderTH}>SOURCE FROM</th>
                <th className={borderTH}>MARKETING</th>
                <th className={borderTH}>MEDIA</th>
                <th className={borderTH}>PRICE LEVEL</th>
                <th className={borderTH}>PAYMENT TERM</th>
                <th className={borderTH}>MAX BALANCE</th>
                <th className={borderTH}>BANK</th>
                <th className={borderTH}>BANK ACCOUNT</th>
                <th className={borderTH}>BANK BENEFICIARY</th>
                <th className={borderTH}>BANK BRANCH</th>
                <th className={borderTH}>ADDRESS TYPE</th>
                <th className={borderTH}>COUNTRY</th>
                <th className={borderTH}>PROVINCE</th>
                <th className={borderTH}>REGENCY</th>
                <th className={borderTH}>SUBDISTRICT</th>
                <th className={borderTH}>VILLAGE</th>
                <th className={borderTH}>ADDRESS</th>
              </tr>
            </thead>
            <tbody>
              {tableLoading ? <tr><td colSpan={44}><div className='flex justify-start ml-12'><Loading loading /></div></td></tr> : fields?.length === 0
                ? <tr><td className="text-center" colSpan={44}>No Data Available</td></tr>
                : fields.map((field, key) => {

                  const idexValue = dataReview?.[key]
                  const previewId = dataReview?.[key]?.preview_id
                  const status = dataReview?.[key]?.status
                  const isProfileDisable = ![ "customer_name" ].every((field) => dataReview?.[key]?.[field]);

                  return (
                    <tr key={field.id}>
                      <td className={borderTH}>{TableNumber({ dataLength: dataSingle?.data?.pagination_data?.size, pageCurrent: pagination?.page, index: key, limit: pagination.limit, totalData: pagination?.total })}</td>

                      {/* FULL NAME */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.customer_name`}
                          render={({ field, fieldState }) => (
                            <Input 
                              {...field}
                              className={`${inputClass} w-[300px]`} 
                              placeholder="-"
                              onChange={(e) => {
                                field.onChange(e.target.value)
                                // if(e.target.value === "") {
                                //   methods.setValue(`datavalue.${key}.handphone`, "");
                                //   methods.setValue(`datavalue.${key}.email`, "");
                                //   methods.setValue(`datavalue.${key}.website`, "");
                                //   methods.setValue(`datavalue.${key}.card_label`, null);
                                //   methods.setValue(`datavalue.${key}.group_card`, "2");
                                //   methods.setValue(`datavalue.${key}.category_customer_id`, null);
                                //   methods.setValue(`datavalue.${key}.source_from`, "");
                                //   methods.setValue(`datavalue.${key}.employee_id`, null);
                                //   methods.setValue(`datavalue.${key}.media`, "");
                                //   methods.setValue(`datavalue.${key}.price_level_id`, null);
                                //   methods.setValue(`datavalue.${key}.payment_term_id`, null);
                                //   methods.setValue(`datavalue.${key}.max_balance`, 0);
                                //   methods.setValue(`datavalue.${key}.bank_id`, null);
                                //   methods.setValue(`datavalue.${key}.bank_account`, 0);
                                //   methods.setValue(`datavalue.${key}.bank_beneficiary`, "");
                                //   methods.setValue(`datavalue.${key}.bank_branch`, "");
                                //   methods.setValue(`datavalue.${key}.address_type_id`, null);
                                //   methods.setValue(`datavalue.${key}.country_id`, null);
                                //   methods.setValue(`datavalue.${key}.province_id`, null);
                                //   methods.setValue(`datavalue.${key}.regency_id`, null);
                                //   methods.setValue(`datavalue.${key}.subdistrict_id`, null);
                                //   methods.setValue(`datavalue.${key}.village_id`, null);
                                //   methods.setValue(`datavalue.${key}.address`, "");
                                // }
                              }}
                              error={fieldState.error?.message}
                            />
                          )}
                        />
                      </td>
                      
                      {/* HANDPONE  */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.handphone`}
                          render={({ field, fieldState }) => (
                            <Input 
                              {...field}
                              className={`${inputClass} w-[150px]`} 
                              placeholder="-"
                              onChange={(e) => {
                                const result = e.target.value.replace(/[^\d,]/g, '').replace(/[^\d.]/g, '')
                                field.onChange(result)
                              }}
                              error={fieldState.error?.message}
                              disabled={isProfileDisable}
                            />
                          )}
                        />
                      </td>

                      {/* EMAIL   */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.email`}
                          render={({ field, fieldState }) => (
                            <Input 
                              {...field}
                              type="email"
                              className={`${inputClass} w-[150px]`} 
                              placeholder="-"
                              onChange={(e) => field.onChange(e.target.value)}
                              error={fieldState.error?.message}
                              disabled={isProfileDisable}
                            />
                          )}
                        />
                      </td>

                      {/* WEBSITE   */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.website`}
                          render={({ field, fieldState }) => (
                            <Input 
                              {...field}
                              className={`${inputClass} w-[150px]`} 
                              placeholder="-"
                              onChange={(e) => field.onChange(e.target.value)}
                              error={fieldState.error?.message}
                              disabled={isProfileDisable}
                            />
                          )}
                        />
                      </td>

                      {/* CARD LABEL */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.card_label`}
                          render={({ field, fieldState }) => (
                            <Select 
                              controlClass={`${inputClass} w-[200px]`} 
                              placeholder="Select Card Label"
                              options={dataCardLabel}
                              value={field.value ? dataCardLabel.find((item) => item.value?.toString() === field.value?.toString()) : null}
                              onChange={(e) => field.onChange(e?.value)}
                              error={fieldState.error?.message}
                              isDisabled={isProfileDisable}
                            />
                          )}
                        />
                      </td>

                      {/* GROUP */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.group_card`}
                          render={({ field, fieldState }) => (
                            <Select 
                              controlClass={`${inputClass} w-[200px]`} 
                              placeholder="Select Group"
                              options={dataGroup}
                              value={field.value ? dataGroup.find((item) => item.value?.toString() === field.value?.toString()) : null}
                              onChange={(e) => field.onChange(e?.value)}
                              error={fieldState.error?.message}
                              isDisabled={isProfileDisable}
                            />
                          )}
                        />
                      </td>

                      {/* CATEGORY */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.category_customer_id`}
                          render={({ field, fieldState }) => (
                            <div className="flex items-top">
                              <Select 
                                controlClass={`${inputClass} w-[200px] !rounded-r-none`} 
                                placeholder="Select Category"
                                isLoading={productCategory?.isLoading}
                                options={productCategory?.data}
                                value={field.value ? productCategory?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                                onChange={(e) => field.onChange(e?.value)}
                                error={fieldState.error?.message}
                                isDisabled={isProfileDisable}
                              />
                              <Button
                                type="button"
                                color="primary"
                                className="!rounded-r-lg"
                                onClick={() => setModalConfig({ ...modalConfig, show: true, action: "CATYGORY" })}
                                disabled={isProfileDisable}
                              >
                                <FaPlus />
                              </Button>
                            </div>
                          )}
                        />
                      </td>

                      {/* SOURCE FROM  */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.source_from`}
                          render={({ field, fieldState }) => (
                            <Input 
                              {...field}
                              className={`${inputClass} w-[150px]`} 
                              placeholder="-"
                              onChange={(e) => field.onChange(e.target.value)}
                              error={fieldState.error?.message}
                              disabled={isProfileDisable}
                            />
                          )}
                        />
                      </td>

                      {/* MARKETING */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.employee_id`}
                          render={({ field, fieldState }) => (
                            <div className="flex items-top">
                              <Select 
                                controlClass={`${inputClass} w-[200px] !rounded-r-none`} 
                                placeholder="Select marketing"
                                isLoading={productMarketing?.isLoading}
                                options={productMarketing?.data}
                                value={field.value ? productMarketing?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                                onChange={(e) => field.onChange(e?.value)}
                                error={fieldState.error?.message}
                                isDisabled={isProfileDisable}
                              />
                              <Button
                                type="button"
                                color="primary"
                                className="!rounded-r-lg"
                                onClick={() => setModalConfig({ ...modalConfig, show: true, action: "MARKETING" })}
                                disabled={isProfileDisable}
                              >
                                <FaPlus />
                              </Button>
                            </div>
                          )}
                        />
                      </td>

                      {/* MEDIA  */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.media`}
                          render={({ field, fieldState }) => (
                            <Input 
                              {...field}
                              className={`${inputClass} w-[150px]`} 
                              placeholder="-"
                              onChange={(e) => field.onChange(e.target.value)}
                              error={fieldState.error?.message}
                              disabled={isProfileDisable}
                            />
                          )}
                        />
                      </td>

                      {/* PRICE LEVEL */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.price_level_id`}
                          render={({ field, fieldState }) => (
                            <div className="flex items-top">
                              <Select 
                                controlClass={`${inputClass} w-[200px] !rounded-r-none`} 
                                placeholder="Select price level"
                                isLoading={productPriceLevel?.isLoading}
                                options={productPriceLevel?.data}
                                value={field.value ? productPriceLevel?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                                onChange={(e) => field.onChange(e?.value)}
                                error={fieldState.error?.message}
                                isDisabled={isProfileDisable}
                              />
                              <Button
                                type="button"
                                color="primary"
                                className="!rounded-r-lg"
                                onClick={() => setModalConfig({ ...modalConfig, show: true, action: "PRICE_LEVEL" })}
                                disabled={isProfileDisable}
                              >
                                <FaPlus />
                              </Button>
                            </div>
                          )}
                        />
                      </td>

                      {/* PAYMENT TERM */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.payment_term_id`}
                          render={({ field, fieldState }) => (
                            <div className="flex items-top">
                              <Select 
                                controlClass={`${inputClass} w-[200px] !rounded-r-none`} 
                                placeholder="Select payment term"
                                isLoading={productPaymentTerm?.isLoading}
                                options={productPaymentTerm?.data}
                                value={field.value ? productPaymentTerm?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                                onChange={(e) => field.onChange(e?.value)}
                                error={fieldState.error?.message}
                                isDisabled={isProfileDisable}
                              />
                              <Button
                                type="button"
                                color="primary"
                                className="!rounded-r-lg"
                                onClick={() => setModalConfig({ ...modalConfig, show: true, action: "PAYMENT_TERM" })}
                                disabled={isProfileDisable}
                              >
                                <FaPlus />
                              </Button>
                            </div>
                          )}
                        />
                      </td>

                      {/* MAX BALANCE */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.max_balance`}
                          render={({ field, fieldState }) => (
                            <NumberInput 
                              {...field}
                              key={`datavalue.${key}.max_balance`}
                              decimalSeparator="." 
                              thousandSeparator=","
                              value={field.value !== null ? field.value : null}
                              className={`${inputClass} w-[100px]`} 
                              placeholder="-"
                              onValueChange={(e) => field.onChange(e.floatValue)}
                              error={fieldState.error?.message}
                              disabled={isProfileDisable}
                            />
                          )}
                        />
                      </td>

                      {/* BANK */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.bank_id`}
                          render={({ field, fieldState }) => (
                            <div className="flex items-top">
                              <Select 
                                controlClass={`${inputClass} w-[200px] !rounded-r-none`} 
                                placeholder="Select bank"
                                isLoading={productBank?.isLoading}
                                options={productBank?.data}
                                value={field.value ? productBank?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                                onChange={(e) => field.onChange(e?.value)}
                                error={fieldState.error?.message}
                                isDisabled={isProfileDisable}
                              />
                              <Button
                                type="button"
                                color="primary"
                                className="!rounded-r-lg"
                                onClick={() => setModalConfig({ ...modalConfig, show: true, action: "BANK" })}
                                disabled={isProfileDisable}
                              >
                                <FaPlus />
                              </Button>
                            </div>
                          )}
                        />
                      </td>

                      {/* BANK ACCOUNT */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.bank_account`}
                          render={({ field, fieldState }) => (
                            <NumberInput 
                              {...field}
                              key={`datavalue.${key}.bank_account`}
                              decimalSeparator="." 
                              thousandSeparator=","
                              value={field.value !== "" ? field.value : null}
                              className={`${inputClass} w-[100px]`} 
                              placeholder="-"
                              onValueChange={(e) => field.onChange(e.floatValue)}
                              error={fieldState.error?.message}
                              disabled={isProfileDisable}
                            />
                          )}
                        />
                      </td>

                      {/* BANK BENEFICIARY  */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.bank_beneficiary`}
                          render={({ field, fieldState }) => (
                            <Input 
                              {...field}
                              className={`${inputClass} w-[150px]`} 
                              placeholder="-"
                              onChange={(e) => field.onChange(e.target.value)}
                              error={fieldState.error?.message}
                              disabled={isProfileDisable}
                            />
                          )}
                        />
                      </td>

                      {/* BANK BRANCH  */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.bank_branch`}
                          render={({ field, fieldState }) => (
                            <Input 
                              {...field}
                              className={`${inputClass} w-[150px]`} 
                              placeholder="-"
                              onChange={(e) => field.onChange(e.target.value)}
                              error={fieldState.error?.message}
                              disabled={isProfileDisable}
                            />
                          )}
                        />
                      </td>
                      
                      {/* ADDRESS TYPE */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.address_type_id`}
                          render={({ field, fieldState }) => (
                            <Select 
                              controlClass={`${inputClass} w-[200px]`} 
                              placeholder="Select type address"
                              isLoading={productTypeAddress?.isLoading}
                              options={productTypeAddress?.data}
                              value={field.value ? productTypeAddress?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                              onChange={(e) => field.onChange(e?.value)}
                              error={fieldState.error?.message}
                              isDisabled={isProfileDisable}
                            />                          
                          )}
                        />
                      </td>

                      {/* COUNTRY */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.country_id`}
                          render={({ field, fieldState }) => (
                            <Select 
                              controlClass={`${inputClass} w-[200px]`} 
                              placeholder="Select Country"
                              isLoading={productCountry?.isLoading}
                              options={productCountry?.data}
                              value={field.value ? productCountry?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                              onChange={(e) => field.onChange(e?.value)}
                              error={fieldState.error?.message}
                              isDisabled={isProfileDisable}
                            />
                          )}
                        />
                      </td>

                      {/* PROVINCE */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.province_id`}
                          render={({ field, fieldState }) => (
                            <Select
                              key={key}
                              controlClass={`${inputClass} w-[200px]`} 
                              placeholder="Select province"
                              isLoading={productProvince?.isLoading}
                              options={productProvince?.data.filter((item: any) => item.country_id?.toString() === dataReview?.[key]?.country_id?.toString())}
                              value={field.value ? productProvince?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                              onChange={(e) => field.onChange(e?.value)}
                              error={fieldState.error?.message}
                              isDisabled={isProfileDisable || !dataReview?.[key]?.country_id}
                            />
                          )}
                        />
                      </td>

                      {/* REGENCY */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.regency_id`}
                          render={({ field, fieldState }) => (
                            <Select 
                              key={key}
                              controlClass={`${inputClass} w-[200px]`} 
                              placeholder="Select regency"
                              isLoading={productRegency?.isLoading}
                              options={productRegency?.data.filter((item: any) => item.province_id?.toString() === dataReview?.[key]?.province_id?.toString())}
                              value={field.value ? productRegency?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                              onChange={(e) => field.onChange(e?.value)}
                              error={fieldState.error?.message}
                              isDisabled={isProfileDisable || (!dataReview?.[key]?.country_id || !dataReview?.[key]?.province_id)}
                            />
                          )}
                        />
                      </td>

                      {/* SUBDISTRICT */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.subdistrict_id`}
                          render={({ field, fieldState }) => (
                            <Select 
                              controlClass={`${inputClass} w-[200px]`} 
                              placeholder="Select subdistrict"
                              isLoading={productSubdistrict?.isLoading}
                              options={productSubdistrict?.data.filter((item: any) => item.regency_id?.toString() === dataReview?.[key]?.regency_id?.toString())}
                              value={field.value ? productSubdistrict?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                              onChange={(e) => field.onChange(e?.value)}
                              error={fieldState.error?.message}
                              isDisabled={isProfileDisable || (!dataReview?.[key]?.country_id || !dataReview?.[key]?.province_id || !dataReview?.[key]?.regency_id)}
                            />
                          )}
                        />
                      </td>

                      {/* VILLAGE */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.village_id`}
                          render={({ field, fieldState }) => (
                            <Select 
                              controlClass={`${inputClass} w-[200px]`} 
                              placeholder="Select village"
                              isLoading={productVillage?.isLoading}
                              options={productVillage?.data.filter((item: any) => item.subdistrict_id?.toString() === dataReview?.[key]?.subdistrict_id?.toString())}
                              value={field.value ? productVillage?.data.find((item) => item.value?.toString() === field.value?.toString()) : null}
                              onChange={(e) => field.onChange(e?.value)}
                              error={fieldState.error?.message}
                              isDisabled={isProfileDisable || (!dataReview?.[key]?.country_id || !dataReview?.[key]?.province_id || !dataReview?.[key]?.regency_id || !dataReview?.[key]?.subdistrict_id)}
                            />
                          )}
                        />
                      </td>

                      {/* ADDRESS */}
                      <td className={borderTH}>
                        <Controller
                          control={methods.control}
                          name={`datavalue.${key}.address`}
                          render={({ field, fieldState }) => (
                            <Input 
                              {...field}
                              className={`${inputClass} w-[300px]`} 
                              placeholder="-"
                              onChange={(e) => field.onChange(e.target.value)}
                              error={fieldState.error?.message}
                              disabled={isProfileDisable}
                            />
                          )}
                        />
                      </td>

                      <td className={borderTH}>{Number(status) === StatusEnum.Review ? "Review" : "Submit"}</td>
                      {dataPage?.status === 1 && <td className={borderTH}>
                        <div className='flex justify-center gap-3 items-center'>
                          {Number(status) === StatusEnum.Review && <ActionButton.Delete onClick={() => handleDeleteSingle(previewId)} />}
                          <FaRegSave
                            className={`h-[20px] w-[20px] cursor-pointer ${isProfileDisable ? "text-gray-400" : "" }`} 
                            onClick={() => (!isProfileDisable) && handleUpdateSingle(idexValue)} 
                          />
                        </div>
                      </td>}
                      {dataPage?.status === 1 && <td className={borderTH}>
                        <div className='flex justify-center gap-3 items-center'>
                          <input 
                            type='checkbox'
                            className='w-[22px] h-[22px] checkbox checkbox-primary'
                            checked={checkedIndexes.includes(key)}
                            onChange={() => handleCheckboxChange(key)}
                            disabled={isProfileDisable}
                            >
                            
                          </input>
                        </div>
                      </td>}
                    </tr>
                  )
                })
              }
            </tbody>
          </BaseTable>
        </div>
      </FormProvider>
      <div className="mt-5 flex justify-between">
        <div className='w-[50%] mt-[-20px]'>
          <PaginationData data={dataSingle?.data} pagination={pagination} setPagination={setPagination} />
        </div>
        <div className="flex justify-end">
          <div className="flex gap-3">
            <Button color="error" onClick={() =>  navigate(-1)}>CANCEL</Button>
            {dataPage?.status === 1 && <Button color="primary" disabled={isDisabled && selectedData?.length === 0} onClick={handleCreateSingle}>SUBMIT {`${selectedData?.length !== 0 ? "ITEMS" : ""}`}</Button>}
          </div>
        </div>
      </div>

      {/* CATYGORY */}
      {modalConfig?.show && modalConfig?.action === "CATYGORY" && (
        <PopupCategory
          toggle={() => {
            setModalConfig({ ...modalConfig, show: false, action: "" })
            productCategory?.refetch()
          }}
        />
      )}

      {/* MARKETING */}
      {modalConfig?.show && modalConfig?.action === "MARKETING" && (
        <Modal
          isOpen 
          title="CREATE NEW EMPLOYEE" 
          size="full" 
          closeModal={() => {
            setModalConfig({ ...modalConfig, show: false, action: "" })
            productMarketing?.refetch()
          }}>
            <NewEmployee asModal />
        </Modal>
      )}

      {/* PRICE LEVEL */}
      {modalConfig?.show && modalConfig?.action === "PRICE_LEVEL" && (
        <PopupPriceLevel
          toggle={() => {
            setModalConfig({ ...modalConfig, show: false, action: "" })
            productPriceLevel?.refetch()
          }}
        />
      )}

      {/* PAYMENT TERM */}
      {modalConfig?.show && modalConfig?.action === "PAYMENT_TERM" && (
        <PopupPaymentTerm
          toggle={() => {
            setModalConfig({ ...modalConfig, show: false, action: "" })
            productPaymentTerm?.refetch()
          }}
        />
      )}
      
      {/* BANK */}
      {modalConfig?.show && modalConfig?.action === "BANK" && (
        <PopupBank
          toggle={() => {
            setModalConfig({ ...modalConfig, show: false, action: "" })
            productBank?.refetch()
          }}
        />
      )}
    </section>
  )
}

// useEffect(() => {
//   if (Array.isArray(dataSingle?.data?.payload)) {
//     const updatedPayload = dataSingle.data.payload.map((item) => ({
//       ...item,
//       customer_name: item.customer_name || "",
//       handphone: item.handphone || "",
//       email: item.email || "",
//       website: item.website || "",
//       card_label: item.card_label || null,
//       group_card: item.group_card || "2",
//       category_customer_id: item.category_customer_id || null,
//       source_from: item.source_from || "",
//       employee_id: item.employee_id || null,
//       media: item.media || "",
//       price_level_id: item.price_level_id || null,
//       payment_term_id: item.payment_term_id || null,
//       max_balance: item.max_balance || 0,
//       bank_id: item.bank_id || null,
//       bank_account: item.bank_account || 0,
//       bank_beneficiary: item.bank_beneficiary || "",
//       bank_branch: item.bank_branch || "",
//       address_type_id: item.address_type_id || null,
//       country_id: item.country_id || null,
//       province_id: item.province_id || null,
//       regency_id: item.regency_id || null,
//       subdistrict_id: item.subdistrict_id || null,
//       village_id: item.village_id || null,
//       address: item.address || "",
//     }));

//     methods.reset({
//       datavalue: updatedPayload,
//     });
//   }
//   // eslint-disable-next-line
// }, [dataSingle?.data?.payload, methods.reset]);